import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { UserSettingsService } from '../../user-profile/services/user-settings.service';
import { DisplayMode } from '../../user-profile/enums/display-mode.enum';

@Injectable({ providedIn: 'root' })
export class DisplayModeService {
    displayMode$ = this.userSettingsService.settings$.pipe(map(settings => settings.displayMode));

    constructor(private userSettingsService: UserSettingsService) {}

    setDisplayMode(mode: DisplayMode) {
        this.userSettingsService.updateSettings({ displayMode: mode });
    }
}
